import CheckList from "./CheckList";
import LeaverCard from "./LeaverCard";
import TaskProgress from "./TaskProgress";
import OffBoardingForm from "./OffBoardingForm";

const OffBoardingComponent = {
  CheckList,
  LeaverCard,
  TaskProgress,
  OffBoardingForm,
};

export default OffBoardingComponent